/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_Agent_InstructionsInputs */

const en_rd_fix_agent_instructions = /** @type {(inputs: Rd_Fix_Agent_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add AGENTS.md or CLAUDE.md with the build, test and style rules an agent must follow.`)
};

const id_rd_fix_agent_instructions = /** @type {(inputs: Rd_Fix_Agent_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan AGENTS.md atau CLAUDE.md berisi aturan build, tes, dan gaya kode yang wajib diikuti agent.`)
};

/**
* | output |
* | --- |
* | "Add AGENTS.md or CLAUDE.md with the build, test and style rules an agent must follow." |
*
* @param {Rd_Fix_Agent_InstructionsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_agent_instructions = /** @type {((inputs?: Rd_Fix_Agent_InstructionsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_Agent_InstructionsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_agent_instructions(inputs)
	return en_rd_fix_agent_instructions(inputs)
});